import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  icon: Icon,
  iconPosition = 'right',
  className = '',
  ...props 
}) => {
  const baseClasses = 'flex items-center justify-center rounded-lg font-bold transition-all touch-manipulation';
  
  const variants = {
    primary: 'bg-primary hover:bg-primary-hover text-white shadow-lg shadow-primary/20 hover:scale-105 active:scale-100',
    secondary: 'bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 text-white',
    outline: 'border border-primary text-primary hover:bg-primary hover:text-white',
  };

  const sizes = {
    sm: 'h-9 sm:h-10 px-3 sm:px-4 text-xs sm:text-sm',
    md: 'h-10 sm:h-12 px-4 sm:px-6 text-sm sm:text-base',
    lg: 'h-11 sm:h-12 lg:h-14 px-5 sm:px-6 lg:px-8 text-sm sm:text-base',
  };

  return (
    <motion.button
      whileHover={{ scale: variant === 'primary' ? 1.05 : 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {Icon && iconPosition === 'left' && <Icon className="mr-1.5 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5" />}
      {children}
      {Icon && iconPosition === 'right' && <Icon className="ml-1.5 sm:ml-2 w-4 h-4 sm:w-5 sm:h-5" />}
    </motion.button>
  );
};

export default Button;
